<div class="caracteristicas-container" *ngIf="comodidades">
  <div class="caracteristica" *ngFor="
      let comodidade of comodidades ?? '' | split : ','
    ">
    <mat-icon color="primary">check</mat-icon>
    <span>{{ comodidade.trim() }}</span>
  </div>
</div>